module.exports = __webpack_public_path__ + "media/images/caret-1d211da6c2298bceb0cf600f06ef231e.svg";